import React from 'react';
import Image from 'next/image';
import s from './Select.module.scss';
import ArrowDown from './ArrowDown.svg?url';

interface SelectItem {
  value: string | number;
  name: string | number;
}

interface SelectProps {
  items?: SelectItem[];
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  label?: string;
  placeholder?: string;
  isError?: boolean;
  helperText?: string;
  dataTestId?: string;
}

const Select: React.FC<SelectProps> = ({
  label = '',
  value = '',
  placeholder = '',
  items = [],
  onChange = () => {},
  isError = false,
  helperText = '',
  dataTestId = '',
}) => (
  <div className={s.container} data-testid={dataTestId}>
    <p>{label}</p>
    <div className={s.selectContainer}>
      <select
        onChange={onChange}
        name={label}
        value={value || ''}
      >
        {placeholder && (
          <option disabled hidden>
            {placeholder}
          </option>
        )}
        {items.map((item) => (
          <option key={item.value} value={item.value}>
            {item.name}
          </option>
        ))}
      </select>
      <figure className={s.iconContainer}>
        <Image src={ArrowDown} className={s.logo} data-testid="ArrowDown" alt='ArrowDown' />
      </figure>
    </div>
    {isError && <p className={s.helperText}>{helperText}</p>}
  </div>
);

export default Select;
